import React, { useState } from "react";
import "./InputBirthDay.scss";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.css";
import { DatePickerCustom } from "../../../../../../../../DatePickerCustom/DatePickerCustom";

interface IInputBirthDay {
  birthdayData: Date | null;
  setBirthdayData: React.Dispatch<React.SetStateAction<Date | null>>;
}

const InputBirthDay = ({ birthdayData, setBirthdayData }: IInputBirthDay) => {
  return (
    <div className="entrance-f-item-bc">
      <DatePickerCustom
        startDate={birthdayData}
        setStartDate={setBirthdayData}
      />
    </div>
  );
};

export { InputBirthDay };
